import { NestApiType, nestCall } from '@/composables/nestApi';

export async function getShopPendingSimpleCharges(idShop: number): Promise<any> {
  return nestCall('post', NestApiType.PAYMENTS, '/shopify/shop-pending-simple-charges', {}, '', { idShop });
}

export async function getShopPendingRecurringCharges(idShop: number): Promise<any> {
  return nestCall('post', NestApiType.PAYMENTS, '/shopify/shop-pending-recurring-charges', {}, '', { idShop });
}

export async function checkSpmTag(idShop: number): Promise<any> {
  return nestCall('post', NestApiType.DEFAULT, '/shopify/check-spm-tag', {}, '', { idShop });
}

export async function getTagInstallerLinkRedirect(idShop: number): Promise<any> {
  return nestCall('post', NestApiType.DEFAULT, '/shopify/get-tag-link-redirect', {}, '', { idShop });
}

export async function getBirthdateMetafield(idShop: number): Promise<any> {
  return nestCall('post', NestApiType.DEFAULT, '/shopify/get-birthdate-metafield', {}, '', { idShop });
}

export async function setBirthdateMetafield(idShop: number, namespace: string, key: string): Promise<any> {
  return nestCall('post', NestApiType.DEFAULT, '/shopify/set-birthdate-metafield', {}, '', { idShop, namespace, key });
}
